import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="eJNq1nUW48I1"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      viewBox="0 0 50 48"
      {...props}
    >
      <defs>
        <linearGradient
          id="eJNq1nUW48I10-fill"
          x1={24.879}
          x2={24.879}
          y1={36.662}
          y2={10.8}
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop id="eJNq1nUW48I10-fill-0" offset="0%" stopColor="#d60000" />
          <stop id="eJNq1nUW48I10-fill-1" offset="100%" stopColor="#ffcf24" />
          <stop id="eJNq1nUW48I10-fill-2" offset="100%" stopColor="#ffbd14" />
        </linearGradient>
      </defs>
      <g id="eJNq1nUW48I2" transform="translate(0 .015)">
        <path
          id="eJNq1nUW48I3"
          fill="#9a0000"
          d="M41.282 11.296A21.17 21.17 0 0 0 32.215 4.8a21.262 21.262 0 0 0-7.41-1.324c-2.608 0-5.112.468-7.42 1.328A21.145 21.145 0 0 0 8.327 11.3 20.747 20.747 0 0 0 3.667 25a20.708 20.708 0 0 0 3.148 10.452 21.17 21.17 0 0 0 17.99 9.94 21.19 21.19 0 0 0 17.984-9.932A20.705 20.705 0 0 0 45.945 25c.004-.188.008-.376.008-.568 0-4.972-1.752-9.544-4.671-13.136Zm-3.32 17.616a6.861 6.861 0 0 1-.808 3.264c-1.132 2.1-3.34 3.488-5.935 3.488a7.203 7.203 0 0 1-2.803-.576 7.459 7.459 0 0 1-2.776-2.008l-.756-.884-.76.884a7.503 7.503 0 0 1-2.98 2.092 7.265 7.265 0 0 1-2.599.492c-2.627 0-4.859-1.424-5.975-3.568a6.846 6.846 0 0 1-.768-3.184c0-1.324.336-2.604 1.004-3.924.5-1 1.192-2.016 2.072-3.092.768-.944 1.668-1.912 2.683-2.932a122.983 122.983 0 0 1 3.728-3.536c.708-.652 1.452-1.324 2.223-2.024l1.372-1.248 1.368 1.244c.728.664 1.432 1.3 2.1 1.912 1.391 1.28 2.66 2.46 3.78 3.58 1.043 1.048 1.967 2.04 2.755 3.004.875 1.076 1.571 2.092 2.071 3.092.668 1.32 1.004 2.6 1.004 3.924Z"
          transform="matrix(0 0 0 0 24.806 24.434)"
        />
        <g fill="#ffcf24">
          <path
            id="eJNq1nUW48I5"
            d="M33.235 2.024 32.215 4.8l-3.863 10.512c-.668-.612-1.372-1.248-2.1-1.908l-1.368-1.248-1.371 1.244c-.772.704-1.516 1.376-2.224 2.028L17.386 4.804l-1.02-2.78C18.953.72 21.805 0 24.796 0s5.851.72 8.439 2.024Z"
            transform="translate(0 -18.962)"
          />
          <path
            id="eJNq1nUW48I6"
            d="m21.145 35.172-3.247 9.076L16.554 48c-2.832-.628-5.487-1.872-7.795-3.756A18.47 18.47 0 0 1 3.54 37.36l3.276-1.908 5.755-3.356c1.115 2.144 3.347 3.568 5.975 3.568.892 0 1.78-.176 2.6-.492Z"
            transform="translate(-19.607 19.607)"
          />
          <path
            id="eJNq1nUW48I7"
            d="M46.05 37.36a18.254 18.254 0 0 1-5.22 6.872 18.603 18.603 0 0 1-7.795 3.76l-1.34-3.74-3.279-9.164c.88.372 1.832.576 2.804.576 2.595 0 4.803-1.388 5.935-3.488l5.635 3.284 3.26 1.9Z"
            transform="translate(19.586 19.586)"
          />
          <path
            id="eJNq1nUW48I8"
            d="M49.457 25.004h-3.512l-8.986-.016c-.5-1-1.196-2.016-2.072-3.092-.788-.964-1.712-1.956-2.756-3.004l9.15-7.596 2.42-2.008c2.112 1.964 3.768 4.376 4.796 7.176a18.165 18.165 0 0 1 .96 8.54Z"
            transform="translate(25.713 -25.713)"
          />
          <path
            id="eJNq1nUW48I9"
            d="M17.561 18.964c-1.015 1.02-1.915 1.988-2.683 2.932-.88 1.076-1.572 2.092-2.072 3.092L3.668 25H.144a18.153 18.153 0 0 1 .96-8.536c1.028-2.8 2.684-5.212 4.795-7.176L8.327 11.3l9.234 7.664Z"
            transform="translate(-25.315 -25.315)"
          />
        </g>
        <path
          id="eJNq1nUW48I10"
          fill="url(#eJNq1nUW48I10-fill)"
          fillRule="evenodd"
          d="M26.92 12.66 24.88 10.8l-2.042 1.86C15.586 19.242 10.8 23.597 10.8 28.91c0 4.355 3.407 7.752 7.744 7.752 1.58 0 3.118-.475 4.423-1.291a8.371 8.371 0 0 0 1.913-1.64 8.374 8.374 0 0 0 1.913 1.64 8.382 8.382 0 0 0 4.423 1.29c4.337 0 7.744-3.396 7.744-7.75 0-5.314-4.787-9.669-12.039-16.25ZM24.88 14.86l-.025.023c-3.685 3.344-6.501 5.913-8.432 8.276-1.897 2.324-2.623 4.081-2.623 5.752 0 2.698 2.063 4.752 4.744 4.752 1.542 0 3.072-.734 4.058-1.884l2.278-2.657 2.277 2.657c.986 1.15 2.517 1.884 4.059 1.884 2.68 0 4.744-2.054 4.744-4.752 0-1.671-.727-3.428-2.624-5.752-1.93-2.363-4.746-4.932-8.43-8.276l-.005-.004-.021-.02Z"
          clipRule="evenodd"
          transform="matrix(0 0 0 0 24.879 23.73)"
        />
      </g>
      <script />
    </svg>
  );
};

export default Icon;
